import React from 'react';
import { useStyles } from './AvailabilityCalendar.styles';
import { CalendarDateService } from '@uplift/services';
import { TimeRange } from '@uplift/types';


export const AvailabilityTimesListItem: React.FC<{ range: TimeRange }> = (props) => {
  const ranges = React.useMemo(() => {
    const start = CalendarDateService.date(props.range.start, 'HH:mm:ss');

    if (!start.isValid()) {
      return null;
    }

    const end = CalendarDateService.date(props.range.end, 'HH:mm:ss');

    if (!end.isValid()) {
      return null;
    }

    return [
      start.format('h:mm a'),
      end.format('h:mm a'),
    ].join(' – ');
  }, [ props.range ]);

  if (ranges) {
    return (
      <li>{ranges}</li>
    );
  }

  return null;
};


export const AvailabilityTimesList: React.FC<{ timeRanges: TimeRange[] }> = (props) => {
  const { classes } = useStyles();

  return (
    <ul className={classes.timeList}>
      {props.timeRanges?.map(time => <AvailabilityTimesListItem key={`${time.start}-${time.end}`} range={time} />)}
    </ul>
  );
};
